import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VetClinicPetSpecies} from "../../models/vet-clinic-pet-species.model";
import {PetSpeciesGroup} from "../../models/pet-species-group.model";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-select-species-modal',
  templateUrl: './select-species-modal.component.html',
  styleUrls: ['./select-species-modal.component.scss'],
})
export class SelectSpeciesModalComponent {

  constructor(private modalController: ModalController) {}


  @Input() petSpecies: VetClinicPetSpecies[] = [];
  @Input() groupedPetSpecies: {group: PetSpeciesGroup, species: VetClinicPetSpecies[]}[];
  @Input() onModalSave: (data: any[]) => void;


  toggleSpecies(sp: any, checked: any) {
    const isChecked = checked;
    let updatedSpecies = [...(this.petSpecies || [])];

    if (isChecked) {
      if (!updatedSpecies.some(selected => selected.key === sp.key)) {
        updatedSpecies.push(sp);
      }
    } else {
      updatedSpecies = updatedSpecies.filter(selected => selected.key !== sp.key);
    }

    this.petSpecies = updatedSpecies;
  }

  ionViewWillLeave() {
    if (this.onModalSave) {
      this.onModalSave(this.petSpecies);
    }
  }

  onClose() {
    this.modalController.dismiss();
  }

  isSpeciesSelected(sp: VetClinicPetSpecies): boolean {
    if (!this.petSpecies) return false;
    return this.petSpecies.some(selected => selected.key === sp.key);
  }

  trackByGroupCode(index: number, grouped: {group: PetSpeciesGroup, species: VetClinicPetSpecies[]}): string {
    return grouped.group.code;
  }

  trackBySpeciesKey(index: number, sp: VetClinicPetSpecies): string {
    return sp.key;
  }

  isColumnChecked(group: PetSpeciesGroup) {
    if (!this.petSpecies) return false;
    const numberOfGroupSpecies = this.groupedPetSpecies.find(grouped => grouped.group.code === group.code).species.length;
    const numberOfCheckedSpeciesFromGroup = this.petSpecies.filter(species => species.groupCode === group.code).length;
    return numberOfCheckedSpeciesFromGroup === numberOfGroupSpecies;
  }

  toggleColumn(group: PetSpeciesGroup, $event: any) {
    this.groupedPetSpecies.find(grouped => grouped.group.code === group.code).species.forEach(species => {
      this.toggleSpecies(species, $event);
    })
  }
}
